// Placeholder Redux slice for packages
import { createSlice } from '@reduxjs/toolkit';
const packageSlice = createSlice({
  name: 'package',
  initialState: {},
  reducers: {}
});
export default packageSlice.reducer;
